import { defineStore } from "pinia";
import { getPlatform } from "@/utils/platform";

export const useAppStore = defineStore("app", {
    state: () => ({
        title: import.meta.env.VITE_APP_TITLE || "suplasercut-mobile",
        loading: false,
        platform: "",
    }),
    actions: {
        init() {
            if (typeof window === "undefined") {
                return;
            }
            this.platform = getPlatform();
            this.setTitle(this.title);
        },
        setTitle(title) {
            this.title = title;
            if (typeof document !== "undefined") {
                document.title = title;
            }
        },
        setLoading(loading) {
            this.loading = !!loading;
        },
    },
});

export function initStore(pinia) {
    useAppStore(pinia).init();
}
